import React from "react";
import { Link, useOutletContext } from "react-router-dom";
import { QuickBooksConnectionCard } from "./QuickBooksConnectionCard";

// The QuickBooks page's first tab: the connected company, and a pointer to the
// open exceptions when there are any (the Slack summary of a connector run
// links to this page), or a note when they could not be counted.
export function QuickBooksConnectionTab() {
  const { openExceptions, countFailed } = useOutletContext() ?? {};

  return (
    <>
      <QuickBooksConnectionCard />
      {openExceptions > 0 && (
        <div style={{ marginTop: 16, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, padding: "14px 20px", borderRadius: 12, background: "#FEF3C7", border: "1px solid #F5D77A" }}>
          <span style={{ fontSize: 14, color: "#7A3A07" }}>
            {openExceptions === 1
              ? "1 record could not be posted to QuickBooks and needs a decision."
              : `${openExceptions} records could not be posted to QuickBooks and need a decision.`}
          </span>
          <Link to="/support/quickbooks/exceptions" style={{ fontSize: 13, fontWeight: 600, color: "#7A3A07", textUnderlineOffset: 3 }}>
            Review exceptions
          </Link>
        </div>
      )}
      {countFailed && (
        <p style={{ marginTop: 16, fontSize: 13, color: "#626262" }}>
          Could not check for open exceptions. See the{" "}
          <Link to="/support/quickbooks/exceptions" style={{ color: "#151515", fontWeight: 600, textUnderlineOffset: 3 }}>Exceptions tab</Link>.
        </p>
      )}
    </>
  );
}
